export default "__VITE_ASSET__CmfNAKck__"